<template>
  <div>
    <div class="text-weight-bold text-brand-5 q-my-lg">
      <span class="texto-titulo">Encerramento</span>
    </div>
    <div class="fit row justify-between items-start">
      <div class="q-mt-md">
        <ListaEncerramento
          ref="listaEncerramentoRef"
          :pt="pt"
          :usuarioPodeEditar="usuarioPodeEditar"
          @respostasAtualizadas="onRespostasAtualizadas"
        />
      </div>
    </div>
    <span class="text-weight-bold text-brand-5 texto-titulo"
      >Lista de Responsáveis</span
    >
    <div>
      <ListaResponsaveisEncerramento
        :pt="pt"
        :usuarioPodeEditar="usuarioPodeEditar"
      />
    </div>
  </div>
</template>

<script>
import { onMounted, ref, computed } from "@vue/runtime-core";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { useQuasar } from "quasar";
import ListaEncerramento from "./ListaEncerramento.vue";
import ListaResponsaveisEncerramento from "./ListaResponsaveisEncerramento.vue";

export default {
  components: {
    ListaEncerramento,
    ListaResponsaveisEncerramento,
  },
  setup() {
    const route = useRoute();
    const store = useStore();
    const quasar = useQuasar();
    const router = useRouter();
    const observacaoEncerramento = ref("");
    const ptId = route.params.ptId;
    const pt = ref(false);
    const listaEncerramentoRef = ref(null);
    const buscarDetalhePt = async () => {
      store.dispatch("pdt/hiddenHeader", true);
      const resposta = await store.dispatch("pdt/buscarDetalhePt", { ptId });
      pt.value = resposta.data.resultado.dados;
    };

    const voltar = async () => {
      router.push({ name: "pdt-pt-detalhe" });
    };

    const usuarioPodeEditar = computed(() => {
      if (!pt.value) {
        return false;
      }

      return (
        store.getters["autenticacao/usuarioLogado"].id ===
        pt.value.emissorMatricula
      );
    });

    const proximaEtapa = async () => {
      const status = {
        aberto: "pdt/finalizarEdicao",
        aguardando_assinaturas: "pdt/iniciarAtividades",
        iniciado: "pdt/encerrarAtividades",
        encerrado: "pdt/finalizar",
      };

      try {
        if (pt.value.status === "encerrado" && listaEncerramentoRef.value) {
          const validacao =
            listaEncerramentoRef.value.verificarImpedimentoEncerramento();

          if (!validacao.podeEncerrar) {
            quasar.notify({
              message: validacao.mensagem,
              color: "negative",
              multiLine: true,
              timeout: 8000,
              actions: [
                {
                  label: "Fechar",
                  color: "white",
                  handler: () => {
                    /* ... */
                  },
                },
              ],
            });
            return;
          }
        }

        if (
          pt.value.status == "encerrado" &&
          observacaoEncerramento.value != ""
        ) {
          await store.dispatch("pdt/observacaoEncerramento", {
            pt: pt.value.ptId,
            observacao: observacaoEncerramento.value,
          });
        }

        let resposta = await store.dispatch(status[pt.value.status], {
          ptId: pt.value.ptId,
        });

        quasar.notify({
          message: resposta.data.resultado.Mensagem,
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });

        buscarDetalhePt();
        redirecionar(ptId);
      } catch (error) {
        let mensagem = "Ocorreu um erro ao alterar status";
        if (error.response) {
          mensagem = error.response.data.erro.mensagem;
        }
        quasar.notify({
          message: mensagem,
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const redirecionar = (ptId) => {
      router.push({ name: "pdt-pt-detalhe", params: { ptId } });
    };

    const onRespostasAtualizadas = () => {};

    onMounted(buscarDetalhePt);
    return {
      pt,
      ptId,
      voltar,
      usuarioPodeEditar,
      proximaEtapa,
      redirecionar,
      listaEncerramentoRef,
      onRespostasAtualizadas,
    };
  },
};
</script>

<style>
.elipse {
  width: 12px;
  height: 12px;
  border-radius: 50%;
}
.cursor {
  cursor: pointer;
}
.texto-titulo {
  margin-left: 10px;
  font-size: 17px;
}
@media (max-width: 600px) {
  .texto-titulo {
    margin-left: 10px;
    font-size: 14px;
  }
}
</style>
